<template lang="pug">
  .card.height-100
    .card-body
      .columns.align-center
        .column.col-auto
          user-avatar.avatar-lg(:user="subscription.person")
        .column.text-ellipsis
          .text-bold.text-ellipsis {{ subscription.person.fullName }}
          .text-small {{ subscription.person.email }}
        .column.col-auto
          div(:class="status.class") {{ status.label }}
      .divider.text-center(data-content="Plano")
      div
        span.text-bold {{ subscription.plan.title }}
        span  /
        span.text-bold  {{ subscription.plan.price | currency('R$ ') }}
    .card-footer
      .columns.align-center
        .column
          .text-small Assinado em #[span.text-bold {{ subscription.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          router-link.btn.btn-link.btn-actioon.btn-sm.tooltip(
            data-tooltip="Exibir"
            :to="{ name: 'subscriptions.show', params: { id: subscription.id } }"
          )
            i.fas.fa-eye
</template>

<script>
import { mapSubscriptionStatus } from '@/lib/constants'

export default {
  props: { subscription: { type: Object, required: true } },
  computed: {
    status() {
      return mapSubscriptionStatus[this.subscription.status]
    },
  },
}
</script>
